import { DollarSign } from 'lucide-react';
import EmptyState from '../EmptyState';

export default function PipelineListView({ deals, stages, onDealClick }) {
  const stageMap = {};
  for (const stage of stages) {
    stageMap[stage.id] = stage;
  }

  const formattedValue = (value) => {
    if (value == null) return '-';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    }).format(value);
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  if (deals.length === 0) {
    return (
      <EmptyState
        illustration="pipeline"
        headline="No deals yet"
        description="Create your first deal to start tracking your sales pipeline progress."
      />
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 dark:border-gray-700">
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Deal
            </th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Company
            </th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Value
            </th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Stage
            </th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Owner
            </th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              Created
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
          {deals.map((deal) => {
            const stage = stageMap[deal.stage_id];
            return (
              <tr
                key={deal.id}
                onClick={() => onDealClick?.(deal)}
                className="hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
              >
                <td className="py-3 px-4">
                  <span className="font-medium text-gray-900 dark:text-gray-100">
                    {deal.name}
                  </span>
                </td>
                <td className="py-3 px-4 text-gray-600 dark:text-gray-400">
                  {deal.company_name || '-'}
                </td>
                <td className="py-3 px-4">
                  {deal.value != null ? (
                    <span className="flex items-center gap-1 text-gray-700 dark:text-gray-300 font-medium">
                      <DollarSign className="w-3 h-3" />
                      {formattedValue(deal.value)}
                    </span>
                  ) : (
                    <span className="text-gray-400">-</span>
                  )}
                </td>
                <td className="py-3 px-4">
                  {stage && (
                    <span
                      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium"
                      style={{
                        backgroundColor: stage.color + '15',
                        color: stage.color,
                        border: `1px solid ${stage.color}30`,
                      }}
                    >
                      <span
                        className="w-1.5 h-1.5 rounded-full"
                        style={{ backgroundColor: stage.color }}
                      />
                      {stage.name}
                    </span>
                  )}
                </td>
                <td className="py-3 px-4 text-gray-600 dark:text-gray-400">
                  {deal.owner_name || '-'}
                </td>
                <td className="py-3 px-4 text-gray-500 dark:text-gray-400 text-xs">
                  {formatDate(deal.created_at)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
